export enum FixtureLevel {
    LEVEL1 = 1, // Silver
    LEVEL2 = 2, // Gold
    LEVEL3 = 3, // Platin
}
